// ----------------------------------------------------------------------
// <copyright file="Izenda.TinyMCEUtils.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import { isNil } from 'lodash/fp';
let tinymce;

function getTinyMCEId(id: string) {
  tinymce = tinymce || require('tinymce/tinymce');
  return tinymce.get(id);
};

export default {
  /**
   * Get content of Tinymce
   * @param  {[type]} id [description]
   * @return {[type]}    [description]
   */
  getContent: (id) => {
    return getTinyMCEId(id).getContent();
  },

  /**
   * Execute command for tiny mce
   * @param  {String} command [description]
   * @param  {String} id      [description]
   * @return {Boolean}         [description]
   */
  execCommand: (id, command) => {
    if (isNil(command) || isNil(id))
      return false;

    getTinyMCEId(id).execCommand(command, false);
  },

  /**
   * Insert content into tinymce
   * @param  {String} id      [description]
   * @param  {String} content [description]
   */
  insertContent: (id, content) => {
    getTinyMCEId(id).execCommand('mceInsertContent', false, content);
  },

  /**
   * Check dirty form input
   * @param  {String} id  [description]
   * @return {Boolean}    [description]
   */
  checkDirty: (id) => {
    return getTinyMCEId(id).isDirty();
  },

  /**
   * [showNotify description]
   * @param  {[type]} id      [description]
   * @param  {[type]} message [description]
   */
  showNotify: (id, message, type) => {
    type = type || 'info';
    getTinyMCEId(id).windowManager.alert(message);
  },

  /**
   * Check selects a cell in inserted table anything
   * @param  {string} id [description]
   * @return {[type]}    [description]
   */
  checkSelectedCell: (id: string) => {
    var editor = getTinyMCEId(id);
    var selectedCells = editor.dom.select('td[data-mce-selected],th[data-mce-selected]');
    var selectedElm = selectedCells[0];
    if (!selectedElm) {
      selectedElm = editor.selection.getStart();
    }

    return editor.dom.getParent(selectedElm, 'td,th');
  }
};



// WEBPACK FOOTER //
// ./ui/share/components/controls/TinyMCE/Izenda.TinyMCEUtils.js